<span
  [class]="'overflow-hidden material-symbols-outlined ' + iconClass"
  [style.font-size]="size + 'px'"
  [style.font-variation-settings]="'\'opsz\' ' + size"
  [style.color]="color"
  [style.width]="size + 'px'"
  [style.height]="size + 'px'"
  [style]="iconStyle"
>
  <ng-content></ng-content>
</span>
